import type { IFile } from '../types';

export const getFileKey = (file?: IFile | null): string => {
  const { name, format } = file || {};
  return `${name}.${format}`;
};
